export default "__VITE_ASSET__7Vu6$F$Z__"